import { render } from "./Post.vue?vue&type=template&id=5c6865dc&scoped=true"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=5c6865dc&lang=css"
import "./Post.vue?vue&type=style&index=1&id=5c6865dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6865dc"]])

export default __exports__